export const receiptBankApiPaths = <const>{
    integrateCompany: 'receiptBank/integrateCompany',
};
